import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BiHeart, BiRupee, BiSolidHeart } from "react-icons/bi";
import { PiBathtub } from "react-icons/pi";
import { IoBedOutline, IoMapOutline } from "react-icons/io5";
import { MdFileCopy } from "react-icons/md";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { BsBuildingCheck } from "react-icons/bs";
import { LoginPopupContext } from '../../loginpopup/LoginPopupContext';
import { mediaUrl, baseURL } from '../../axiosInterceptor/axiosInterceptorC';

function PropertyBox({ 
    propertyLink, 
    propertyImage, 
    propertyPurposeTag, 
    propertyId, 
    propertyName, 
    propertyLocation, 
    propertyDate, 
    propertyPrice, 
    propertyType, 
    savedStatus,  // Added savedStatus prop
    onPropertySettingClick, 
    propertySeen, 
    propertyContacted,
    onPropertyIdclick,
    addedId,
}) {
    const [isSaved, setIsSaved] = useState(savedStatus); // Use savedStatus from props to set initial state
    const [isLoading, setIsLoading] = useState(true);
    const [isPopupVisible, setIsPopupVisible] = useContext(LoginPopupContext);
    const token = localStorage.getItem('jwtToken');
    const login_id = localStorage.getItem('login_id');
    const handleSaveClick = async () => {
        if (!token) {
            // Store the previous action in localStorage
            localStorage.setItem("previousAction", JSON.stringify({
                action: "handleSaveClick",
                data: { propertyId, savedstatus: !isSaved }
            }));
            setIsPopupVisible(true);
            return;
        }
    else{
        const newSavedState = !isSaved;
        setIsSaved(newSavedState);

        try {
            const response = await axios.post(
                `${baseURL}/addpropertywishlist`, 
                { propertyId, login_id, savedstatus: newSavedState },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );
            
            if (response.status === 200) {
               
                if (newSavedState) {
                  
                    toast.success("Property saved successfully!");
                } else {
                    toast.info("Property removed from saved list.");
                }
            } else {
                toast.error(response.data.message || "Failed to save property.");
            }
        } catch (error) {
            toast.error("An error occurred while saving the property.");
        }
        }
    };

    const handleCopyId = () => {
        navigator.clipboard.writeText(propertyId)
            .then(() => toast.success(`Property ID ${propertyId} copied to clipboard!`))
            .catch(() => toast.error("Failed to copy Property ID."));
    };

    useEffect(() => {
        setIsLoading(false);
    }, []);

    return (
        <>
            <Tooltip id="my-tooltip" />

            {/* {isLoading ? (
                <div className='SkeletonLoader'>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                </div>
            ) : ( */}
                <div className="propertyBox">
                    <Link to={propertyLink} className="propertyLink"></Link>
                    
                    {login_id !== null && addedId == login_id ? (
                        <div className="propertyBoxMyPrpertyIcon tootlTip">
                            <BsBuildingCheck />
                            <div className="tootlTipPopup">My Property</div>
                        </div>
                    ) : (
                        <div className="propertyBoxSaveBtn" onClick={handleSaveClick}>
                            {isSaved ? <BiSolidHeart style={{ color: 'red' }} /> : <BiHeart />}
                        </div>
                    )}

                    <div className="propertyBoxThumbnail">
                        <div className="propertyPurposeTag">{propertyPurposeTag === 'sell' ? 'sale' : propertyPurposeTag}</div>
                        <img src={propertyImage} alt="Property" loading="lazy"  />
                        <div className="propertyIdBox" onClick={handleCopyId}>
                        {/* data-tooltip-id="my-tooltip" data-tooltip-content="Copy ID" */}
                            <p>ID :</p>
                            <h3>{propertyId}</h3>
                            <div className="copyIdBtn"><MdFileCopy /></div>
                        </div>
                    </div>
                    <div className="propertyBoxDetails">
                        <div className="propertyBoxDetailsCol1">
                            <div className="propertyDate">Posted on: {propertyDate}</div>
                            <div className="propertyName">{propertyName}</div>
                            <div className="propertyLocation">{propertyLocation}</div>
                        </div>
                        <div className="propertyBoxDetailsCol2">
                            <div className="propertyFeature">
                                {propertyType === "Land" && (
                                    <div className="propertyFeatureBox landArea">
                                        <div className="propertyFeatureBoxIcon">
                                            <IoMapOutline />
                                        </div>
                                        <p>6.25 Cent</p>
                                    </div>
                                )}
                                {(propertyType === "Apartment" || propertyType === "Home" || propertyType === "Villa") && (
                                    <>
                                        <div className="propertyFeatureBox bedroom">
                                            <div className="propertyFeatureBoxIcon">
                                                <IoBedOutline />
                                            </div>
                                            <p>4</p>
                                        </div>
                                        <div className="propertyFeatureBox bathroom">
                                            <div className="propertyFeatureBoxIcon">
                                                <PiBathtub />
                                            </div>
                                            <p>5</p>
                                        </div>
                                        <div className="propertyFeatureBox homeArea">
                                            <div className="propertyFeatureBoxIcon">
                                                <IoMapOutline />
                                            </div>
                                            <p>2500 sq.ft</p>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="propertyBoxDetailsCol3">
                            <div className="propertyPrice"><BiRupee /> {propertyPrice}</div>
                            <div className="propertyBoxDetailsSeenContacted">
                                <div className={`propertySeen ${propertySeen ? "active" : ""}`}>
                                    {propertySeen ? <span>Already Seen</span> : ""}
                                </div>
                                <div className={`propertyContacted ${propertyContacted ? "active" : ""}`}>
                                    {propertyContacted ? <span>Already Contacted</span> : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="propertyBoxBtnArea">
                        <div className="propertyBoxSettingBtn" onClick={() => { onPropertySettingClick(); onPropertyIdclick(propertyId);}}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            {/* )} */}
        </>
    );
}

export default PropertyBox;
